export enum ActivityType {
    YAZHOULONG = 'yazhoulong',
    puladuo_baoke_jiudian_20240804 = 'puladuo_baoke_jiudian_20240804',
    puladuo_baoke_jiayou_20240804 = 'puladuo_baoke_jiayou_20240804',
    puladuo_qianke_20240804 = 'puladuo_qianke_20240804',
    avalon_20240804_test='avalon_20240804_test',
    test_20240808='test_20240808',
    alipay_spi_1103='alipay_spi_1103',
    // 试驾
    alipay_mini_program_1103='alipay_mini_program_1103',
    // 新试驾
    alipay_mini_program_0127='alipay_mini_program_0127',
    // 权益
    alipay_mini_program_quanyi_1120='alipay_mini_program_quanyi_1120',
    // 会员
    alipay_mini_program_member_1120='job_member_12_06',
    // 2月活动
    alipay_mini_program_0208='alipay_mini_program_0208',

    job_benz_11_24='job_benz_11_24',

    // 六月活动
    toyota_20250601_lead='toyota_20250601_lead',
    toyota_20250601_vip='toyota_20250601_vip',

    // 七月活动
    alipay_mini_2507 = 'manufacturer_toyota',

    // 昊铂HL 8月活动
    haobing_20250801 = 'haobing_20250801',

    // 阿里 4月活动
    alipay_mini_2604 = 'alipay_mini_2604',

    // 阿里 5月活动
    alipay_mini_2605 = 'alipay_mini_2605',

    // ali bz 5月活动

    alipay_h5_202605 = 'alipay_h5_202605',

    // ali 丰田 5月活动 全车系
    alipay_mini_2605_series = 'alipay_mini_2605_series',

    // ali bz 8月活动
    alipay_h5_202608 = 'alipay_h5_202608',

    
}

export const ActivityTypeMap = {
    [ActivityType.alipay_h5_202608]: {
        text: '【支付宝】8-9月bZ双车效果广告',
    },

    [ActivityType.alipay_mini_2604]: {
        text: '丰田小程序-4月活动-荣放',
    },

    [ActivityType.alipay_mini_2605]: {
        text: '丰田小程序-4月活动2-荣放',
    },
    [ActivityType.alipay_mini_2605_series]: {
        text: '丰田小程序-5月活动-全车系',
    },

    [ActivityType.alipay_h5_202605]: {
        text: '【支付宝】26年5月bZ效果广告',
    },

    [ActivityType.alipay_mini_2507] : {
        text: '丰田-7月-活动'
    },
    
    [ActivityType.toyota_20250601_lead]: {
        text: '丰田-6月-线索',
    },
    [ActivityType.toyota_20250601_vip]: {
        text: '丰田-6月-入会',
    },
    [ActivityType.haobing_20250801]: {
        text: '昊铂HL-8月活动',
    },
    [ActivityType.job_benz_11_24]: {
        text: '奔驰小程序',
    },
    [ActivityType.alipay_mini_program_1103]: {
        text: '丰田小程序-试驾',
    },
    [ActivityType.alipay_mini_program_0127]: {
        text: '丰田小程序-新试驾',
    },
    [ActivityType.alipay_mini_program_quanyi_1120]: {
        text: '丰田小程序-权益',
    },
    [ActivityType.alipay_mini_program_member_1120]: {
        text: '丰田小程序-会员',
    },
    [ActivityType.alipay_mini_program_0208]: {
        text: '丰田小程序-2月活动',
    },
    

    [ActivityType.alipay_spi_1103]: {
        text: '车生活落地页',
    },
    [ActivityType.YAZHOULONG]: {
        text: '亚洲龙-保客',
    },
    [ActivityType.puladuo_baoke_jiudian_20240804]: {
        text: '普拉多-保客-酒店权益',
    },
    [ActivityType.puladuo_baoke_jiayou_20240804]: {
        text: '普拉多-保客-加油权益',
    },
    [ActivityType.puladuo_qianke_20240804]: {
        text: '普拉多-潜客',
    },
    [ActivityType.avalon_20240804_test]: {
        text: '亚洲龙-潜客',
    },
    [ActivityType.test_20240808]: {
        text: '内部测试活动',
    },
    
}

export const MemberTypeMap = {
    1: {
        text: '新客',
    },
    0: {
        text: '老客',
    },
};

export const sourceTypeMap = {
    'media': {
        text: '离线录入',
    },
    'alipay_shijia': {  
        text: '支付宝广告',
    },
    'h5': {
        text: 'H5广告',
    },
}

export enum SendStatus {
    All = 'all',
    Send = 1,
    unSend = 0,
    Fail = -1,
};

export const SendStatusName = {
    [SendStatus.All]: {
        title: '全部',
        text: '全部',
        color: 'red',
    },
    [SendStatus.Fail]: {
        title: '推送失败',
        text: '推送失败',
        color: 'red'
    },
    [SendStatus.unSend]:  {
        title: '未推送',
        text: '未推送',
        color: 'gray'
    },
    [SendStatus.Send]:  {
        title: '推送成功',
        text: '推送成功',
        color: 'green'
    },
    
}

export const leadsBizCodeName = {
    issued: {
        title: '待审核',
        text: '待审核',
        color: 'blue'
    },
    fail_finished: {
        title: '审核驳回',
        text: '审核驳回',
        color: 'red'
    },
    success_finished: {
        title: '审核通过',
        text: '审核通过',
        color: 'green'
    }
}

export const sendMsgWhite = [ActivityType.test_20240808, ActivityType.avalon_20240804_test, ActivityType.alipay_mini_2604, ActivityType.alipay_mini_2605, ActivityType.alipay_mini_2605_series];

